module.exports = __webpack_public_path__ + "img/virgin-logo.f5b61b3a.svg";